import { toast } from 'sonner';

/**
 * Os avisos que a interface mostra em vez de gravar numa tabela cadastral.
 *
 * NENHUMA das cinco tabelas cadastrais aceita escrita hoje — nem de `ADMIN`
 * (docs/ALVOS.md, Onda 2): nao ha politica de escrita no banco nem rota na API
 * (`apps/api/src/modulos/` so tem `eu`, `govbr` e `senha`). Os botoes de cadastro
 * novo e de acao em lote existem porque o dono do repositorio decidiu, em
 * 2026-08-20, que a interface pode ficar pronta antes do backend — mas nenhum
 * deles pode fingir que gravou o que nao gravou. Por isso nenhum chama API
 * nenhuma: cada um so mostra o aviso certo, em portugues, sem detalhe tecnico
 * (CLAUDE.md, "Regras de interface", item 8).
 */
export const AVISO_DE_CADASTRO_INDISPONIVEL = {
  title: 'Cadastro ainda não disponível',
  description: 'Estamos preparando esta funcionalidade. Em breve você poderá salvar por aqui.',
} as const;

/** Mesmo motivo do aviso de cadastro, para acoes que mudam a situacao de quem ja esta credenciado. */
export const AVISO_DE_ACAO_INDISPONIVEL = {
  title: 'Ação ainda não disponível',
  description:
    'Estamos preparando esta funcionalidade. Em breve você poderá aplicar ações por aqui.',
} as const;

/**
 * Aviso das exportacoes de relatorio (`PDF oficial`, `XLSX`, `CSV`).
 *
 * Os tres botoes existem em `/operacao/relatorios` porque o dono do repositorio
 * decidiu, em 2026-09-08, que o cartao do catalogo oficial deve ficar igual ao
 * do prototipo. Nenhum deles gera arquivo: nao ha rota de exportacao em
 * `apps/api/src/modulos/`, so `eu`, `govbr` e `senha`. Por isso mostram o aviso
 * honesto em vez de abrir um download que nunca vem.
 */
export const AVISO_DE_EXPORTACAO_INDISPONIVEL = {
  title: 'Exportação ainda não disponível',
  description:
    'Estamos preparando esta funcionalidade. Em breve você poderá baixar este relatório.',
} as const;

/** O formato dos avisos acima: título curto e uma frase dizendo o que esperar. */
export interface AvisoCurto {
  title: string;
  description: string;
}

/**
 * Mostra um aviso curto na tela.
 *
 * Sempre pelo `sonner`: o `<Toaster />` montado em `App.tsx` é o dele. O
 * `useToast` do shadcn (`@/nucleo/ganchos/use-toast`) guarda o aviso numa fila
 * que nenhum componente desenha, e o clique parecia não fazer nada. A regra do
 * ESLint `no-restricted-imports` impede que ele volte.
 */
export function mostrarAviso(aviso: AvisoCurto): void {
  toast(aviso.title, { description: aviso.description });
}
